import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IWindow } from '@phdsoft/window';
import { ChangesWorkflowService } from 'src/app/template/changes-workflow/changes-workflow.service';

@Component({
  selector: 'app-change-justification',
  templateUrl: './change-justification.component.html',
  styleUrls: ['./change-justification.component.scss']
})
export class ChangeJustificationComponent implements OnInit {

  public optionsWindow: IWindow = {
    Position: 'center',
    PositionMini: '',
    VisibleMini: false,
    Header: {
      Icon: 'info',
      VisibleTitle: false,
      Title: 'Modal Confirm',
      Visible: false
    }
  };
  change: any
  textJustification:string = ''
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly changesWorkflowService:ChangesWorkflowService
  ) {
    this.change = data
   }

  ngOnInit() {
  }

  save(){
    this.changesWorkflowService.addJustification(this.change.fieldId, this.textJustification)

  }
}
